module.exports = __webpack_public_path__ + "img/icon-bg(3).2360586a.svg";